import { ReferenceBusiness, } from "./reference-business";
import { ReferenceContact, } from "./reference-contact";
export class Reference {
    constructor(business, contact) {
        this.className = "Reference";
        if (!business) {
            throw new Error("Must specify business");
        }
        if (!contact) {
            throw new Error("Must specify contact");
        }
        this.business = business;
        this.contact = contact;
    }
    get id() {
        return `${this.business.id};${this.contact.id}`;
    }
    get url() {
        if (this.contact.id) {
            return `/references/contacts/show/${this.contact.id}`;
        }
        return `/references/organizations/show/${this.business.id}`;
    }
    get preferredName() {
        const business = this.business;
        const contact = this.contact;
        const loadedBusiness = ReferenceBusiness.load(business);
        const loadedContact = ReferenceContact.load(contact);
        return `${loadedBusiness.preferredName} - ${loadedContact.preferredName}`;
    }
    matches(matchText) {
        return this.contact.matches(matchText) || this.business.matches(matchText);
    }
}
export const CommunityOrgTypeSentinel = "__CommunityOrgType__";
export const NoOrgTypeSentinel = "__NoOrgType__";
export const minimumReferenceSearchLength = 3;
export function referenceSearchQueryTerm(term) {
    const trimmed = term.trim();
    if (trimmed.length < minimumReferenceSearchLength) {
        return "";
    }
    return trimmed;
}
const categoryHealthCare = "Health Care";
const categoryHousingCommunity = "Housing Community";
const categoryProfessional = "Professional";
const categoryOther = "Other";
// TODO: This needs review. We really don't need to have both ReferralMappings
// and ReferralTypesOptions. This needs to be cleaned up.
// For now, be cautious if you're adding new referral sources. They need to be
// added in both places.
export const ReferralMappings = {
    Clinic: {
        humanReadable: "Clinic",
        category: "Health Care",
    },
    "Clinician Home Visits": {
        humanReadable: "Clinician Home Visits",
        category: "Health Care",
    },
    "Corporate Office": {
        humanReadable: "Corporate Office",
        category: "Health Care",
    },
    "Home Health": {
        humanReadable: "Home Health",
        category: "Health Care",
    },
    "Home Medical Equipment": {
        humanReadable: "Home Medical Equipment",
        category: "Health Care",
    },
    Hospice: {
        humanReadable: "Hospice",
        category: "Health Care",
    },
    Hospital: {
        humanReadable: "Hospital",
        category: "Health Care",
    },
    "Mental Health": {
        humanReadable: "Mental Health",
        category: "Health Care",
    },
    "Medical Transport": {
        humanReadable: "Medical Transport",
        category: "Health Care",
    },
    Physician: {
        humanReadable: "Physician",
        category: "Health Care",
    },
    "Rehab Center": {
        humanReadable: "Rehab Center",
        category: "Health Care",
    },
    "Skilled Nursing Facility": {
        humanReadable: "Skilled Nursing Facility",
        category: "Health Care",
    },
    "Transitional Care Unit": {
        humanReadable: "Transitional Care Unit",
        category: "Health Care",
    },
    "Other Health": {
        humanReadable: "Other (Health)",
        category: "Health Care",
    },
    "Assisted Living": {
        humanReadable: "Assisted Living",
        category: "Housing Community",
    },
    "Care Home": {
        humanReadable: "Care Home",
        category: "Housing Community",
    },
    CCRC: {
        humanReadable: "CCRC",
        category: "Housing Community",
    },
    "Independent Living": {
        humanReadable: "Independent Living",
        category: "Housing Community",
    },
    "Memory Care": {
        humanReadable: "Memory Care",
        category: "Housing Community",
    },
    "Housing Community": {
        humanReadable: "Other (Housing Community)",
        category: "Housing Community",
    },
    Accessibility: {
        humanReadable: "Accessibility",
        category: "Professional",
    },
    Assessor: {
        humanReadable: "Assessor",
        category: "Professional",
    },
    Attorney: {
        humanReadable: "Attorney",
        category: "Professional",
    },
    "Adult Day Care": {
        humanReadable: "Adult Day Care",
        category: "Professional",
    },
    "Care Manager": {
        humanReadable: "Care Manager",
        category: "Professional",
    },
    CPA: {
        humanReadable: "CPA",
        category: "Professional",
    },
    "EMT Fire Police": {
        humanReadable: "EMT, Fire, Police",
        category: "Professional",
    },
    "Financial Planning": {
        humanReadable: "Financial Planning",
        category: "Professional",
    },
    "Guardianship and Trust Services": {
        humanReadable: "Guardianship & Trust Services",
        category: "Professional",
    },
    "Geriatric Care": {
        humanReadable: "Geriatric Care",
        category: "Professional",
    },
    "Home Care": {
        humanReadable: "Home Care",
        category: "Professional",
    },
    "Home Security": {
        humanReadable: "Home Security",
        category: "Professional",
    },
    Insurance: {
        humanReadable: "Insurance",
        category: "Professional",
    },
    "Move Manager": {
        humanReadable: "Move Manager",
        category: "Professional",
    },
    "Real Estate": {
        humanReadable: "Real Estate",
        category: "Professional",
    },
    "Social Work": {
        humanReadable: "Social Work",
        category: "Professional",
    },
    Transportation: {
        humanReadable: "Transportation",
        category: "Professional",
    },
    "Placement Referral Agency": {
        humanReadable: "Placement / Referral Agency",
        category: "Professional",
    },
    "Other Professional": {
        humanReadable: "Other (Professional)",
        category: "Professional",
    },
    Association: {
        humanReadable: "Association",
        category: "Other",
    },
    "Online Digital": {
        humanReadable: "Online Digital",
        category: "Other",
    },
    Personal: {
        humanReadable: "Personal / Non Business",
        category: "Other",
    },
    "Religious Organization": {
        humanReadable: "Religious Organization",
        category: "Other",
    },
    "Senior Center": {
        humanReadable: "Senior Center",
        category: "Other",
    },
    Vendor: {
        humanReadable: "Vendor",
        category: "Other",
    },
    Other: {
        humanReadable: "Other",
        category: "Other",
    },
    "Professional Fiduciary": {
        humanReadable: "Professional Fiduciary",
        category: "Professional",
    },
};
// Goal is to reconcile ReferralTypesOptions with the above ReferralMappings
// SUPER LAME that we have both of these!!!!
export const ReferralTypesOptions = [
    {
        header: categoryHealthCare,
        groupOptions: [
            { value: "Clinic", text: "Clinic" },
            { value: "Clinician Home Visits", text: "Clinician Home Visits" },
            { value: "Corporate Office", text: "Corporate Office" },
            { value: "Home Health", text: "Home Health" },
            { value: "Home Medical Equipment", text: "Home Medical Equipment" },
            { value: "Hospice", text: "Hospice" },
            { value: "Hospital", text: "Hospital" },
            { value: "Mental Health", text: "Mental Health" },
            { value: "Medical Transport", text: "Medical Transport" },
            { value: "Physician", text: "Physician" },
            { value: "Rehab Center", text: "Rehab Center" },
            {
                value: "Skilled Nursing Facility",
                text: "Skilled Nursing Facility",
            },
            {
                value: "Transitional Care Unit",
                text: "Transitional Care Unit",
            },
            {
                value: "Other Health",
                text: "Other (Health)",
            },
        ],
    },
    {
        header: categoryHousingCommunity,
        groupOptions: [
            {
                value: "Assisted Living",
                text: "Assisted Living",
            },
            { value: "Care Home", text: "Care Home" },
            { value: "CCRC", text: "CCRC" },
            {
                value: "Independent Living",
                text: "Independent Living",
            },
            {
                value: "Memory Care",
                text: "Memory Care",
            },
            {
                value: "Housing Community",
                text: "Other (Housing Community)",
            },
        ],
    },
    {
        header: categoryProfessional,
        groupOptions: [
            {
                value: "Accessibility",
                text: "Accessibility",
            },
            { value: "Assessor", text: "Assessor" },
            { value: "Attorney", text: "Attorney" },
            { value: "Adult Day Care", text: "Adult Day Care" },
            { value: "Care Manager", text: "Care Manager" },
            { value: "CPA", text: "CPA" },
            {
                value: "EMT Fire Police",
                text: "EMT, Fire, Police",
            },
            {
                value: "Financial Planning",
                text: "Financial Planning",
            },
            {
                value: "Guardianship and Trust Services",
                text: "Guardianship & Trust Services",
            },
            {
                value: "Geriatric Care",
                text: "Geriatric Care",
            },
            { value: "Home Care", text: "Home Care" },
            {
                value: "Home Security",
                text: "Home Security",
            },
            { value: "Insurance", text: "Insurance" },
            {
                value: "Move Manager",
                text: "Move Manager",
            },
            {
                value: "Placement Referral Agency",
                text: "Placement / Referral Agency",
            },
            {
                value: "Professional Fiduciary",
                text: "Professional Fiduciary",
            },
            { value: "Real Estate", text: "Real Estate" },
            { value: "Social Work", text: "Social Work" },
            {
                value: "Transportation",
                text: "Transportation",
            },
            {
                value: "Other Professional",
                text: "Other (Professional)",
            },
        ],
    },
    {
        header: categoryOther,
        groupOptions: [
            {
                value: "Association",
                text: "Association",
            },
            {
                value: "Online Digital",
                text: "Online / Digital",
            },
            {
                value: "Personal",
                text: "Personal / Non Business",
            },
            {
                value: "Religious Organization",
                text: "Religious Organization",
            },
            {
                value: "Senior Center",
                text: "Senior Center",
            },
            { value: "Vendor", text: "Vendor" },
            { value: "Other", text: "Other" },
        ],
    },
];
export const referralTypeDisplayName = (referralType) => ReferralTypesOptions.flatMap(group => group.groupOptions).find(option => option.value === referralType)?.text ?? referralType;
//# sourceMappingURL=reference.js.map